import { render, staticRenderFns } from "./OverlayInspector.vue?vue&type=template&id=dbb7f88c&"
import script from "./OverlayInspector.vue?vue&type=script&lang=js&"
export * from "./OverlayInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports